import { api } from '../config/api'
import { schools, categoryMetric, chosenSkills, methodologies, reviewCategory } from '../constants/statistics'

const metricsBaseEndpoint = '/MetricApi'

export const getApproachByCategoryInfo = () => new Promise(resolve => resolve({ data: categoryMetric }))

export const getSchools = () => new Promise(resolve => resolve({ data: schools }))

export const getResourcesMoreValuedByFilters = () => new Promise(resolve => resolve({ data: reviewCategory }))

export const getChosenMethodologies = () => new Promise(resolve => resolve({ data: methodologies }))

export const getChosenSkills = () => new Promise(resolve => resolve({ data: chosenSkills }))

export const getMostValuedResources = params => api.get(`${metricsBaseEndpoint}/MostValuedByTeachers`, { params })
